import { I9Response } from "../components/i9-task/i9-controlled";
import { buildUrl, CAAS_API_URL } from "../config/urls";
import { fetchWithTimeout } from "../helpers/fetcher";

export const getCaasInfo = async (candidateId: string): Promise<I9Response> => {
  // NOTE: This if statement will be removed on build by webpack
  if (process.env.NODE_ENV === "development") {
    if (process.env.REACT_APP_USE_MOCK_REQUESTS === "true") {
      console.warn("getCaasInfo", CAAS_API_URL, "mocked request", candidateId);
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            isRemote: false,
            secureURL: "https://amazon.com",
            status: "Initiated",
          });
          // reject(new ServerError("", 404));
        }, 1000);
      });
    }
  }

  const url = buildUrl(CAAS_API_URL, {
    candidateId,
    redirectUrl: encodeURIComponent(window.location.href),
  });

  return fetchWithTimeout(url);
};
